import Entity from "./Entity";
import {Easing, Group, Tween} from "@tweenjs/tween.js";

export default class KnightSurprise extends Entity {

    constructor(anchor, texture) {
        super(anchor, texture);

        this._tweens = new Group();

        /*
        this._monster = new PIXI.Sprite(P3.assets.texture("monster" + P3.math.randomInt(1, 4)));
        this._monster.anchor.set(0, 1);
        this._monster.position.set(360, 570);
        this._monster.scale.set(0.95);
        this.addChild(this._monster);

        this._doorRight = new PIXI.Sprite(P3.assets.texture("door_front_wall"));
        this._doorRight.anchor = anchor;
        this.addChild(this._doorRight);

        this._doorClosed = new PIXI.Sprite(P3.assets.texture("door_closed"));
        this._doorClosed.anchor = anchor;
        this.addChild(this._doorClosed);

         */

        /*
        this._chestOpen = new PIXI.Sprite(P3.assets.texture("chest_bottom"));
        this._chestOpen.anchor = anchor;
        this._chestOpen.visible = false;
        this.addChild(this._chestOpen);

        this._lidOpen = new PIXI.Sprite(P3.assets.texture("chest_top"));
        this._lidOpen.anchor = anchor;
        this._lidOpen.visible = false;
        this.addChild(this._lidOpen);

         */

        this._axe = new PIXI.Sprite(P3.assets.texture("axe"));
        this._axe.x = 40;
        this._axe.y = 400;
        this._axe.rotation = -Math.PI * 0.75;
        this._axe.visible = false;
        this.addChild(this._axe);

        this._activated = false;

    }

    update(dt) {
        this._tweens.update();
    }

    activate() {
        if (this._activated)
            return;

        this._activated = true;

        this._view.texture = P3.assets.texture("knight_without_axe");

        this._axe.visible = true;
        new Tween(this._axe, this._tweens)
            .to({rotation: 0}, 600)
            .easing(Easing.Bounce.Out)
            .start();

        P3.audio.playSound("sfx_event_axe_drop_00");
        /*
        this._doorClosed.visible = false;

        new Tween(this._monster, this._tweens)
            .to({x: this._monster.x - 180}, 600)
            .easing(Easing.Bounce.Out)
            .start();

        new Tween(this._monster.scale, this._tweens)
            .to({x: this._monster.scale.x + 0.01, y: this._monster.scale.y - 0.01}, 600 + Math.random() * 100)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start(Math.random() * 500);

         */
    }

}